import { BasketErrorModel } from './BasketErrorModel';
import { BasketApiErrorModel } from './BasketApiErrorModel';

export class BasketHybrisFormErrorModel extends BasketErrorModel {
    public subject: string | null;
    public type: string | null;
    public reason: string | null;
    public formName: string | null;

    constructor(message: string, formName?: string, type?: string, subject?: string, reason?: string, innerError?: BasketApiErrorModel) {
        super(
            message,
            undefined,
            formName,
            [
                { key: 'formName', value: formName ?? null },
                { key: 'subject', value: subject ?? null },
                { key: 'type', value: type ?? null },
                { key: 'reason', value: reason ?? null },
            ],
            innerError
        );

        this.formName = formName ?? null;
        this.subject = subject ?? null;
        this.type = type ?? null;
        this.reason = reason ?? null;
    }
}